import React from 'react';
import styled from 'styled-components';
import { postNotification } from '../../../../redux/api/notifications';

const CardNotifications = (props) => {
    const {
        title,
        descriptions,
        date,
        read,
        allRead,
        launch_url,
        id,
        categoryId,
    } = props;

    const getCardStyles = (read, categoryId) => {
        if (read) {
            return { border: '#d9d9d9', background: '#F9F9F9' };
        }
        const categoryColors = {
            3: { border: '#C29F43', background: '#F9F5EC' },
            5: { border: '#1E8065', background: '#F7FDFB' },
            7: { border: '#B75E26', background: '#FBF0EA' },
        };
        return (
            categoryColors[categoryId] || {
                border: '#5E80DB',
                background: '#5E80DB25',
            }
        );
    };

    const cardStyles = getCardStyles(read, categoryId);

    const handleRedirect = async () => {
        const req = await postNotification(id);

        if (req.error) {
            console.error(req.error);
        }
        if (launch_url) {
            window.location.href = launch_url;
        }
    };

    return (
        <CardFake
            onClick={handleRedirect}
            allRead={allRead}
            launch_url={launch_url}
            read={read}
            borderColor={cardStyles.border}
            background={cardStyles.background}
        >
            <Header>
                <Title
                    allRead={allRead}
                    read={read}
                    borderColor={cardStyles.border}
                >
                    {title}
                </Title>
                <Date>{date}</Date>
            </Header>
            <Body>
                <p>{descriptions}</p>
            </Body>
        </CardFake>
    );
};

export default CardNotifications;

const CardFake = styled.div`
    box-shadow: ${(p) =>
        p.allRead
            ? 'none'
            : p.read
              ? 'none'
              : '0px 4px 6px -4px rgba(24, 39, 75, 0.12), 0px 8px 8px -4px rgba(24, 39, 75, 0.08)'};
    border-radius: 20px;
    background-color: ${(p) => (p.allRead ? '#F9F9F9' : p.background)};
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem 1.5rem;
    border: 1px solid #f1f1f1;
    border-left: 9px solid ${(p) => p.borderColor};
    width: calc(100% - 4rem);

    cursor: ${(p) => (p.launch_url ? 'pointer' : 'default')};
    position: relative;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    gap: 1rem;
`;

const Title = styled.h3`
    flex: 1;
    color: ${(p) =>
        p.allRead ? '#616161' : p.read ? '#616161' : p.borderColor};
    font-weight: bold;
    font-size: 1rem;
    text-align: start;
    text-transform: uppercase;
    margin: 0;
    @media (max-width: 1400px) {
        font-size: 0.95rem;
    }
`;

const Date = styled.p`
    color: #a8a8a8;
    font-size: 1rem;
    white-space: nowrap;
    flex-shrink: 0;
    text-align: end;
    margin: 0;
`;

const Body = styled.div`
    width: 100%;
    p {
        color: #111;
        font-size: 1.1rem;
        margin: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
    @media (max-width: 1400px) {
        p {
            font-size: 0.85rem;
        }
    }
`;
